import { SubmitButton } from "@/components/Auth/shared";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface WaitlistFormActionsProps {
  step: number;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
}

export const WaitlistFormActions = ({
  step,
  isSubmitting,
  onBack,
  onNext,
}: WaitlistFormActionsProps) => (
  <div className="flex gap-4">
    {step > 1 && (
      <button
        type="button"
        onClick={onBack}
        disabled={isSubmitting}
        className="flex flex-1 items-center justify-center gap-2 rounded-lg border border-input px-4 py-3 font-semibold text-muted-foreground transition-all hover:bg-surface-subtle hover:shadow-sm focus-visible:shadow-focus"
      >
        <ChevronLeft className="h-5 w-5" />
        Back
      </button>
    )}

    {step < 3 ? (
      <button
        type="button"
        onClick={onNext}
        className="flex flex-[2] items-center justify-center gap-2 rounded-lg bg-primary px-4 py-3 font-semibold text-white transition-all hover:bg-primary-hover hover:shadow-sm focus-visible:shadow-focus"
      >
        Next
        <ChevronRight className="h-5 w-5" />
      </button>
    ) : (
      <div className={step > 1 ? "flex-[2]" : "w-full"}>
        <SubmitButton isSubmitting={isSubmitting}>Join waitlist</SubmitButton>
      </div>
    )}
  </div>
);
